import * as Sentry from '@sentry/vue'
import { AxiosError } from 'axios'
import { showError } from './ui'

export class HandledError extends Error {
  originalError: any
  constructor(message: string, originalError: any) {
    super(message)
    this.originalError = originalError
  }
}

export function handleError(error: any, baseMessage?: string) {
  const errorMessage = getErrorMessage(error)
  let userMessage = 'Hm, something went wrong.'
  if (errorMessage && baseMessage) {
    userMessage = baseMessage + `\n${errorMessage}`
  } else if (errorMessage) {
    userMessage = errorMessage
  }
  showError(userMessage)
  const skipSentry = error instanceof AxiosError && error.response?.status === 401
  if (!skipSentry) {
    Sentry.captureException(error)
  }
  console.error(error)
  return new HandledError(userMessage, error)
}

function getErrorMessage(error: any): string | null | undefined {
  if (error instanceof AxiosError) {
    let detail = error.response?.data?.detail
    if (Array.isArray(detail)) {
      detail = detail[0]
    }
    if (typeof detail === 'string') {
      return detail
    }
    if (typeof detail?.msg === 'string') {
      return detail.msg
    }
  }
  return error.message
}
